/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailssaved2Inputs */

const en_companydetailssaved2 = /** @type {(inputs: Companydetailssaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing details saved`)
};

const de_companydetailssaved2 = /** @type {(inputs: Companydetailssaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsdaten gespeichert`)
};

/**
* | output |
* | --- |
* | "Billing details saved" |
*
* @param {Companydetailssaved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailssaved2 = /** @type {((inputs?: Companydetailssaved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailssaved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailssaved2(inputs)
	return de_companydetailssaved2(inputs)
});
export { companydetailssaved2 as "companyDetailsSaved" }